module.exports = __webpack_public_path__ + "img/bannerOrange.15624b5e.jpg";